export default "__VITE_ASSET__DbO9A43f__"